import { Currency } from '../../models/Currency';

export const parsePriceByCurrencyJustSymbol = (price: string | undefined, currency: Currency): string => {
    try {
        return currency.currency_format
            .replace('%s', price || '0')
            .replace('%n', currency.currency_name)
            .replace('%c', '')
            .replace('(', '')
            .replace(')', '');
    } catch (error) {
        return price || '0';
    }
};

export const parseCurrencyCode = (currency: Currency): string => {
    try {
        return currency.currency_code.toUpperCase();
    } catch (error) {
        return '';
    }
};
// Returns price with the correct format
export const parsePriceByCurrency = (
    price: string | undefined,
    currency: Currency | null | undefined,
): string => {
    try {
        return (
            currency?.currency_format
                .replace('%s', price || '0')
                .replace('%n', currency.currency_name)
                .replace('%c', currency.currency_code.toUpperCase()) || ''
        );
    } catch (error) {
        return price || '0';
    }
};
export const findCurrencyByCurrencyCode = (
    currency_code: string,
    currencies: Currency[],
): Currency | null | undefined => {
    try {
        return currencies.find(currencyItem => currencyItem.currency_code === currency_code);
    } catch (error) {
        return null;
    }
};
export const parsePriceByCurrencyCode = (
    price: string,
    currency_code: string,
    currencies: Currency[],
): string => {
    try {
        const currencyData = findCurrencyByCurrencyCode(currency_code, currencies);
        return parsePriceByCurrency(price, currencyData);
    } catch (error) {
        return price;
    }
};
